var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-card",
    { staticClass: "gwnl-card", attrs: { shadow: "never" } },
    [
      _vm.showHeader
        ? _c(
            "div",
            {
              staticClass:
                "clearfix standard-size-16 font-medium align-items-center",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("yxt-svg", {
                staticClass: "mr8",
                attrs: {
                  "remote-url": _vm.gwnlMediaDomain + "svg/certifications",
                  width: "28px",
                  height: "28px",
                  "icon-class": "preview-skills",
                },
              }),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("pc_gwnl_model_template__info_skill_title"))
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm.list.length === 0
        ? _c("div", [_c("yxt-empty")], 1)
        : _c(
            "div",
            { staticClass: "clearfix" },
            [
              _c(
                "yxtbiz-skill-viewer",
                _vm._b(
                  { attrs: { list: _vm.list } },
                  "yxtbiz-skill-viewer",
                  _vm.$attrs,
                  false
                )
              ),
            ],
            1
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }